import { Group } from '@mantine/core';
import { IconCalendarEvent, IconFilter, IconMessageCircle } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { openCreateDocumentModal } from '../../../Molecules/Event/Documents/CreateDocumentModal';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { DocumentsContext } from '../../../Service/Context/DocumentsContext';
import { useConversationsWidget } from '../../../Service/Context/HubspotContext';
import { useBookitupScope } from '../../../Service/Context/BookitupSubscriptionContext';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import ActionIconWithText from './ActionIconWithText';
import InboxIconWithIndicator from './InboxIconWithIndicator';
import NavAddIcon from './NavAddIcon';

interface HandlersProps {
  filter: () => void;
}

const DocumentsPageFooter: FC<HandlersProps> = ({ filter }) => {
  const { openWidget } = useConversationsWidget();
  const navigate = useNavigate();
  const { openLicenceModal } = useContext(ViolationContext);
  const { reload } = useContext(DocumentsContext);
  const { isScopeSelected: hasEmailScope } = useBookitupScope('EMAILS');
  const addDocument = () => openCreateDocumentModal({ openLicenceModal, refresh: reload });
  const { unreadMessagesProps } = useContext(ProfileContext);
  const { unreadCount } = unreadMessagesProps ?? { unreadCount: 0 };

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText useDefaultWidth label="Filter" onClick={filter}>
        <IconFilter />
      </ActionIconWithText>
      <ActionIconWithText label="Events" useDefaultWidth onClick={() => navigate('/')}>
        <IconCalendarEvent />
      </ActionIconWithText>
      <NavAddIcon onClick={addDocument} />
      {hasEmailScope ? (
        <ActionIconWithText useDefaultWidth label="Postfach" onClick={() => navigate('/postbox/inbox')}>
          <InboxIconWithIndicator unreadCount={unreadCount} />
        </ActionIconWithText>
      ) : (
        <div style={{ width: '10%' }} />
      )}
      <ActionIconWithText useDefaultWidth label="Support" onClick={openWidget}>
        <IconMessageCircle />
      </ActionIconWithText>
    </Group>
  );
};

export default DocumentsPageFooter;
